// =============================================================================
// weeklyUpdateRequests.js
//
// Chamadas HTTP à API do Weekly Update.
// Padrão: Same as trackerRequests.js
//   1. Cada função faz UMA chamada a UM endpoint.
//   2. Devolvem a Promise do Axios.
//   3. Nenhuma função toca no state ou no dispatch.
// =============================================================================

import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest.js';

const BASE = `${config.API_URL}WeeklyUpdate`;

// ── Current week ─────────────────────────────────────────────────────────────

export const apiGetCurrentWeek = () =>
	AxiosRequest({ method: 'GET', url: `${BASE}/GetCurrentWeek` });

// ── Deadline ─────────────────────────────────────────────────────────────────

export const apiGetDeadline = (weekNumber, year) =>
	AxiosRequest({ method: 'GET', url: `${BASE}/GetDeadline`, params: { weekNumber, year } });

// ── Submissions ──────────────────────────────────────────────────────────────

export const apiGetMySubmission = (weekNumber, year) =>
	AxiosRequest({ method: 'GET', url: `${BASE}/GetMySubmission`, params: { weekNumber, year } });

export const apiGetByWeek = (weekNumber, year, userId = null) =>
	AxiosRequest({ method: 'GET', url: `${BASE}/GetByWeek`, params: { weekNumber, year, userId } });

export const apiSave = (data) =>
	AxiosRequest({ method: 'POST', url: `${BASE}/Save`, data });

export const apiDelete = (weekNumber, year) =>
	AxiosRequest({ method: 'POST', url: `${BASE}/Delete`, params: { weekNumber, year } });

// ── History ─────────────────────────────────────────────────────────────────

export const apiGetMySubmissionHistory = () =>
	AxiosRequest({ method: 'GET', url: `${BASE}/GetMySubmissionHistory` });

export const apiGetAvailableFilters = () =>
	AxiosRequest({ method: 'GET', url: `${BASE}/GetAvailableFilters` });

// ── Role ─────────────────────────────────────────────────────────────────────

export const apiGetMyRole = () =>
	AxiosRequest({ method: 'GET', url: `${BASE}/GetMyRole` });

export const apiGetAllRoles = () =>
	AxiosRequest({ method: 'GET', url: `${BASE}/GetAllRoles` });

export const apiUpsertRole = (userId, role) =>
	AxiosRequest({ method: 'POST', url: `${BASE}/UpsertRole`, data: { userId, role } });

export const apiDeleteRole = (userId) =>
	AxiosRequest({ method: 'POST', url: `${BASE}/DeleteRole`, params: { userId } });

export const apiGetAllPortalUsers = () =>
	AxiosRequest({ method: 'GET', url: `${BASE}/GetAllPortalUsers` });

// ── Manager edit ─────────────────────────────────────────────────────────────
 
export const apiGetSubmissionById = (id) =>
	AxiosRequest({ method: 'GET', url: `${BASE}/GetSubmissionById/${id}` });
 
export const apiManagerEdit = (data) =>
	AxiosRequest({ method: 'PUT', url: `${BASE}/ManagerEdit`, data });